// src/pages/PoaDetail.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Paper, Typography, Button, Box } from '@mui/material';
import api from '../api/axiosConfig';

const PoaDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [poa, setPoa] = useState(null);

  useEffect(() => {
    const fetchPoa = async () => {
      try {
        const res = await api.get(`/poa/${id}/`);
        setPoa(res.data);
      } catch (err) {
        console.error('Error al cargar POA:', err);
        navigate('/poa');
      }
    };
    fetchPoa();
  }, [id, navigate]);

  if (!poa) return <div>Cargando...</div>;

  return (
    <Container>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5">POA #{id} - {poa.descripcion}</Typography>
        <Button variant="outlined" onClick={() => navigate(`/poa/${id}/editar`)}>
          Editar
        </Button>
      </Box>
      <Paper sx={{ p: 2 }}>
        <Typography><strong>Año:</strong> {poa.anno}</Typography>
        <Typography><strong>Departamento ID:</strong> {poa.id_departamento}</Typography>
        <Typography><strong>Activo:</strong> {poa.activo ? 'Sí' : 'No'}</Typography>
        <Typography><strong>Observaciones:</strong> {poa.observaciones || '—'}</Typography>
      </Paper>

      {/* Acciones */}
      <Box sx={{ mt: 3 }}>
        <Button
          variant="contained"
          sx={{ mr: 1 }}
          onClick={() => navigate(`/poa/${id}/metas`)}
        >
          Metas
        </Button>
        <Button
          variant="contained"
          sx={{ mr: 1 }}
          onClick={() => navigate(`/poa/${id}/matriz`)}
        >
          Matriz Lógica
        </Button>
        <Button
          variant="outlined"
          onClick={() => window.open(`/api/reportes/matriz/${id}/`, '_blank')}
        >
          Exportar a PDF
        </Button>
      </Box>
    </Container>
  );
};

export default PoaDetail;